import { styled, Typography, Box } from '@mui/material';

export const FileNameContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const FileName = styled(Typography)(({ theme }) => ({
  marginTop: '8px',
  color: theme.palette.case.neutral.n700,
  [theme.breakpoints.between(300, 400)]: {
    maxWidth: '145px',
  },
}));
